import { Link } from 'react-router-dom';
import type { Project } from '@/types';

interface SideProjectCardProps {
  project: Project & {
    totalHours?: number;
    activeTasks?: number;
    completedTasks?: number;
  };
}

export function SideProjectCard({ project }: SideProjectCardProps) {
  return (
    <Link to={`/side-projects/${project.id}`}>
      <div className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-colors cursor-pointer group">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold text-lg">
              {project.name.charAt(0)}
            </div>
            <div>
              <h3 className="font-bold text-gray-900 group-hover:text-flowky-primary transition-colors">
                {project.name}
              </h3>
              <p className="text-xs text-gray-500">Side Project</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 pt-4 border-t border-white/30">
          <div>
            <p className="text-xs text-gray-600 mb-1">Hours</p>
            <p className="font-semibold text-gray-900">{project.totalHours || 0}h</p>
          </div>
          <div>
            <p className="text-xs text-gray-600 mb-1">Active</p>
            <p className="font-semibold text-orange-600">{project.activeTasks || 0}</p>
          </div>
          <div>
            <p className="text-xs text-gray-600 mb-1">Done</p>
            <p className="font-semibold text-green-600">{project.completedTasks || 0}</p>
          </div>
        </div>

        {project.notes && (
          <p className="text-sm text-gray-600 mt-4 line-clamp-2">{project.notes}</p>
        )}
      </div>
    </Link>
  );
}
